import { Card, CardContent } from './ui/card';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { SUPPLIER_TYPES } from './SupplierFormFields';

const StatCard = ({ value, label, valueClass = 'text-slate-900' }) => (
  <Card>
    <CardContent className="p-4 text-center">
      <p className={`text-2xl font-bold ${valueClass}`}>{value}</p>
      <p className="text-xs text-slate-500">{label}</p>
    </CardContent>
  </Card>
);

const BreakdownRow = ({ label, amount, count }) => (
  <div className="flex justify-between items-center p-2 bg-slate-50 rounded">
    <span className="capitalize">{label}</span>
    <div className="text-right">
      <span className="font-data font-medium">R{amount?.toFixed(2)}</span>
      <span className="text-slate-400 text-sm ml-2">({count} entries)</span>
    </div>
  </div>
);

const SupplierReportDialog = ({ open, onOpenChange, supplier, report }) => {
  const typeLabel = SUPPLIER_TYPES.find(t => t.value === supplier?.supplier_type)?.label;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Supplier Report: {supplier?.name}</DialogTitle>
          <DialogDescription>{typeLabel}</DialogDescription>
        </DialogHeader>

        {report && (
          <div className="space-y-6">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <StatCard value={`R${report.total_amount?.toLocaleString()}`} label="Total Spent" />
              <StatCard value={report.total_entries} label="Transactions" />
              <StatCard value={`${report.total_liters?.toLocaleString()}L`} label="Total Liters" valueClass="text-blue-600" />
            </div>

            {report.by_type?.length > 0 && (
              <div>
                <h4 className="font-medium mb-2">By Cost Type</h4>
                <div className="space-y-2">
                  {report.by_type.map((item) => (
                    <BreakdownRow key={item.type} label={item.type} amount={item.amount} count={item.count} />
                  ))}
                </div>
              </div>
            )}

            {report.by_month?.length > 0 && (
              <div>
                <h4 className="font-medium mb-2">Monthly Breakdown</h4>
                <div className="space-y-2 max-h-40 overflow-y-auto">
                  {report.by_month.map((item) => (
                    <BreakdownRow key={item.month} label={item.month} amount={item.amount} count={item.count} />
                  ))}
                </div>
              </div>
            )}

            <div className="border-t pt-4">
              <h4 className="font-medium mb-2">Contact Information</h4>
              <div className="grid grid-cols-2 gap-2 text-sm">
                {supplier?.contact_person && (
                  <div><span className="text-slate-500">Contact:</span> {supplier.contact_person}</div>
                )}
                {supplier?.phone && (
                  <div><span className="text-slate-500">Phone:</span> {supplier.phone}</div>
                )}
                {supplier?.email && (
                  <div><span className="text-slate-500">Email:</span> {supplier.email}</div>
                )}
                {supplier?.account_number && (
                  <div><span className="text-slate-500">Account:</span> {supplier.account_number}</div>
                )}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SupplierReportDialog;
